import loadable from '@loadable/component';

export default {
    header: loadable(() => import('./HeaderModuleGroup')),
    footer: loadable(() => import('./FooterModuleGroup')),
    main: loadable(() => import('./MainModuleGroup')),
    section: loadable(() => import('./SectionModuleGroup')),
    unknown: loadable(() => import('./UnknownModuleGroup')),
};
